import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/utils/audioCache";
import { reportConfigToBackend } from "@/lib/runtimeConfig";

// Register PWA service worker for offline audio caching
registerServiceWorker();

// Fire-and-forget telemetry: tell the backend which config tier resolved
// this page load (production / build-time-fallback / inferred-fallback).
// Backend uses this to power the admin "config health" widget and to
// alert when too many users land on a fallback tier (= prod is broken).
reportConfigToBackend();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
